// Pure helpers for the DAO Watches tab (DaoListingsTab.jsx).

export const fmt = (n) => Number(n || 0).toLocaleString('en-GB');

export function fmtDuration(s) {
  const sec = Math.round(Number(s) || 0);
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  if (m < 60) return sec % 60 ? `${m}m ${sec % 60}s` : `${m}m`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

let regionNames;
const countryName = (code) => {
  try {
    regionNames ??= new Intl.DisplayNames(['en-GB'], { type: 'region' });
    return regionNames.of(code);
  } catch {
    return code;
  }
};

// Long names that crowd a one-line label.
const SHORT = { GB: 'UK', AE: 'UAE', US: 'USA', HK: 'Hong Kong', MO: 'Macau' };

// "London, UK" — city where known; country name from the ISO code. A city
// that IS the country (Hong Kong, Singapore, Monaco) is said once.
export function placeLabel(city, countryCode) {
  if (!countryCode) return city || null;
  const country = SHORT[countryCode] || countryName(countryCode);
  return city && !country.startsWith(city) ? `${city}, ${country}` : country;
}

// Viewing from somewhere other than where their store trades (a buyer on the road).
export function isAway(v) {
  return Boolean(v.country_code && v.store_country_code && v.country_code !== v.store_country_code);
}

// Storefront buttons (backend StorefrontListingViewController::ACTIONS).
export const ACTION_LABELS = {
  whatsapp: 'WhatsApp',
  cart: 'Added to cart',
  part_exchange: 'Part-exchange',
  source_request: 'Source request',
  share: 'Shared',
  broadcast: 'Broadcast',
};
export const actionLabel = (a) => ACTION_LABELS[a] || a;

// "14:32" in the viewer's own time zone, or null when unknown/invalid.
export function localTime(timeZone, now = new Date()) {
  if (!timeZone) return null;
  try {
    return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', timeZone }).format(now);
  } catch {
    return null;
  }
}

// "6/9 photos · 85% read" — only the parts we have.
export function depthLabel(v) {
  const parts = [];
  if (v.photos_total) parts.push(`${v.photos_seen || 0}/${v.photos_total} photos`);
  if (v.scroll_pct) parts.push(`${v.scroll_pct}% read`);
  return parts.join(' · ');
}

export function sortListings(list, sort) {
  const by = {
    views: (l) => l.views,
    time: (l) => l.avg_seconds,
    people: (l) => l.signed_in,
    newest: (l) => -(l.age_days ?? 0),
    oldest: (l) => l.age_days ?? 0,
  }[sort] || ((l) => l.views);
  return [...list].sort((a, b) => by(b) - by(a) || b.views - a.views);
}
